import Vue from 'vue'
import Router from 'vue-router'

// // 登陆
// import Login from '@/pages/Login';

// // 主页
// import Home from '@/pages/Home';
// import MainPage from '@/pages/Main/MainPage';
// // 添加直播模块
// import LiveIndex from '@/pages/Live/Index';
// import AddLive from '@/pages/Live/AddLive/AddLive';
// import BaseInfo from '@/pages/Live/AddLive/BaseInfo';
// import Participant from '@/pages/Live/AddLive/Participant';
// import Service from '@/pages/Live/AddLive/Service';
// import ModularSetup from '@/pages/Live/AddLive/ModularSetup';
// import AddStatus from '@/pages/Live/AddLive/AddStatus';
// // 直播列表
// import LiveList from '@/pages/Live/LiveList';
// import LiveManage from '@/pages/Live/LiveManage/LiveManage';
// import Photolibrary from '@/pages/Live/LiveManage/Photolibrary';
// import PhotoManage from '@/pages/Live/LiveManage/PhotoManage';
// import Interaction from '@/pages/Live/LiveManage/Interaction';
// import ToSignUp from '@/pages/Live/LiveManage/ToSignUp';
// import ServerInfo from '@/pages/Live/LiveManage/ServerInfo';
// import Published from '@/pages/Live/LiveManage/Published';
// import Hot from '@/pages/Live/LiveManage/Hot';

// // 照片付费列表
// import PayList from '@/pages/Live/PayList';

// // 用户信息

// import User from '@/pages/User/User';
// import UserCount from '@/pages/User/UserCount';
// import UserChange from '@/pages/User/UserChange';
// import ChangeStatus from '@/pages/User/ChangeStatus';

// // 工具页面，为了刷新

// import Reload from '@/pages/Components/Reload';

// // 添加管理员管理模块
// import Administrator from '@/pages/Administrator/Administrator';
// // 添加加盟商管理模块
// import Franchiser from '@/pages/Franchiser/Franchiser';
// // 添加摄影师管理模块
// import PhotographerManage from '@/pages/RoleManage/PhotographerManage/PhotographerManage';
// // 添加修图师管理模块添加修图师管理模块
// import PlannerManage from '@/pages/RoleManage/PlannerManage/PlannerManage';
// // 添加客户管理模块
// import CustomerManage from '@/pages/RoleManage/CustomerManage/CustomerManage';
// // 添加订单管理模块
// import OrderManage from '@/pages/OrderManage/OrderManage';
// import { resolve } from 'path';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/Home'
  },
  {
    path: '/Login',
    component: resolve => require(['@/pages/Login'], resolve)
  },
  {
    path: '/Register',
    component: resolve => require(['@/pages/Register'], resolve)
  },
  {
    path: '/Home',
    component: resolve => require(['@/pages/Home'], resolve),
    meta: {
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      // keepAlive: true,     // 判断是否要缓存该组件
    },
    children: [{
      path: '/',
      component: resolve => require(['@/pages/Main/MainPage'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/MainPage',
      name: 'MainPage',
      component: resolve => require(['@/pages/Main/MainPage'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/AddLive', // 添加活动步奏
      component: resolve => require(['@/pages/Live/AddLive/AddLive'], resolve),
      meta: {
        keepAlive: false
      },
      children: [{
        path: '/',
        component: resolve => require(['@/pages/Live/AddLive/BaseInfo'], resolve)
      },
      {
        path: '/BaseInfo',
        name: 'BaseInfo',
        component: resolve => require(['@/pages/Live/AddLive/BaseInfo'], resolve)
      },
      {
        path: '/Participant',
        name: 'Participant',
        component: resolve => require(['@/pages/Live/AddLive/Participant'], resolve)
      },
      {
        path: '/Service',
        name: 'Service',
        component: resolve => require(['@/pages/Live/AddLive/Service'], resolve)
      },
      {
        path: '/ModularSetup',
        name: 'ModularSetup',
        component: resolve => require(['@/pages/Live/AddLive/ModularSetup'], resolve)
      }

      ]
    },
    {
      path: '/AddStatus/:status/:Id', // 添加活动的状态页面
      name: 'AddStatus',
      component: resolve => require(['@/pages/Live/AddLive/AddStatus'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/Reload', // 刷新页面  空的
      name: 'Reload',
      component: resolve => require(['@/pages/Components/Reload'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/LiveList', // 直播列表
      name: 'LiveList',
      component: resolve => require(['@/pages/Live/LiveList'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/LiveCustomPage', // 定制页列表
      name: 'LiveCustomPage',
      component: resolve => require(['@/pages/Live/LiveCustomPage'], resolve)
    },
    {
      path: '/CustomPageManage/:Id', // 定制页管理
      name: 'CustomPageManage',
      component: resolve => require(['@/pages/Live/PageManage/CustomPageManage'], resolve)
    },
    {
      path: '/PageStatus/:status/:Id', // 添加定制页的状态页面
      name: 'PageStatus',
      component: resolve => require(['@/pages/Live/PageManage/PageStatus'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/PayList/:Id', // 照片付费列表
      name: 'PayList',
      component: resolve => require(['@/pages/Live/PayList'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/LiveManage', // 直播管理
      component: resolve => require(['@/pages/Live/LiveManage/LiveManage'], resolve),
      meta: {
        keepAlive: false
      },
      children: [{
        path: '/',
        component: resolve => require(['@/pages/Live/LiveManage/Photolibrary'], resolve)
      },
      {
        path: '/Photolibrary/:Id',
        name: 'Photolibrary',
        component: resolve => require(['@/pages/Live/LiveManage/Photolibrary'], resolve)
      },
      {
        path: '/PhotoManage',
        component: resolve => require(['@/pages/Live/LiveManage/PhotoManage'], resolve),
        children: [{
          path: '/',
          component: resolve => require(['@/pages/Live/LiveManage/Published'], resolve)
        },
        {
          path: '/Published/:Id',
          name: 'Published',
          component: resolve => require(['@/pages/Live/LiveManage/Published'], resolve)
        },
        {
          path: '/Hot/:Id',
          name: 'Hot',
          component: resolve => require(['@/pages/Live/LiveManage/Hot'], resolve)
        }
        ]
      },
      {
        path: '/Interaction/:Id',
        name: 'Interaction',
        component: resolve => require(['@/pages/Live/LiveManage/Interaction'], resolve)
      },
      {
        path: '/ToSignUp/:Id',
        name: 'ToSignUp',
        component: resolve => require(['@/pages/Live/LiveManage/ToSignUp'], resolve)
      },
      {
        path: '/ServerInfo/:Id',
        name: 'ServerInfo',
        component: resolve => require(['@/pages/Live/LiveManage/ServerInfo'], resolve)
      },
      {
        path: '/upBaseInfo/:Id',
        name: 'upBaseInfo',
        component: resolve => require(['@/pages/Live/UpLive/BaseInfo'], resolve)
      },
      {
        path: '/upParticipant/:Id',
        name: 'upParticipant',
        component: resolve => require(['@/pages/Live/UpLive/Participant'], resolve)
      },
      {
        path: '/upService/:Id',
        name: 'upService',
        component: resolve => require(['@/pages/Live/UpLive/upService'], resolve)
      },
      {
        path: '/upModularSetup/:Id',
        name: 'upModularSetup',
        component: resolve => require(['@/pages/Live/UpLive/ModularSetup'], resolve)
      },
      {
        path: '/LiveOrder/:Id',
        name: 'LiveOrder',
        component: resolve => require(['@/pages/Live/LiveOrder/OrderManage'], resolve),
        meta: {
          keepAlive: false
        }
      }
      ]
    },
    {
      path: '/User',
      component: resolve => require(['@/pages/User/User'], resolve),
      meta: {
        keepAlive: false
      },
      children: [{
        path: '/',
        component: resolve => require(['@/pages/User/User'], resolve)
      },
      {
        path: '/UserCount',
        name: 'UserCount',
        component: resolve => require(['@/pages/User/UserCount'], resolve)
      },
      {
        path: '/UserChange',
        name: 'UserChange',
        component: resolve => require(['@/pages/User/UserChange'], resolve)
      },
      {
        path: '/ChangeStatus',
        name: 'ChangeStatus',
        component: resolve => require(['@/pages/User/ChangeStatus'], resolve)
      }
      ]
    },
    {
      path: '/Administrator', // 管理员管理
      name: 'Administrator',
      component: resolve => require(['@/pages/Administrator/Administrator'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/Franchiser', // 管理员管理  Franchiser
      name: 'Franchiser',
      component: resolve => require(['@/pages/Franchiser/Franchiser'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/PhotographerManage', // 摄影师管理   PhotographerManage
      name: 'PhotographerManage',
      component: resolve => require(['@/pages/RoleManage/PhotographerManage/PhotographerManage'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/photographerRating/:Id', // 摄影师评价管理   photographerRating
      name: 'photographerRating',
      component: resolve => require(['@/pages/RoleManage/photographerRating/photographerRating'], resolve)
      // meta: {
      //     keepAlive: true
      // }
    },
    {
      path: '/PlannerManage', // 修图师管理  PlannerManage
      name: 'PlannerManage',
      component: resolve => require(['@/pages/RoleManage/PlannerManage/PlannerManage'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/PlannerRating/:Id', // 修图师评价管理   PlannerRating
      name: 'PlannerRating',
      component: resolve => require(['@/pages/RoleManage/PlannerRating/PlannerRating'], resolve)
      // meta: {
      //     keepAlive: true
      // }
    },
    {
      path: '/CustomerManage', // 客户管理  CustomerManage
      name: 'CustomerManage',
      component: resolve => require(['@/pages/RoleManage/CustomerManage/CustomerManage'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/OrderManage', // 订单管理  OrderManage
      name: 'OrderManage',
      component: resolve => require(['@/pages/OrderManage/OrderManage'], resolve)
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/OrderInfo/:Id', // 订单管理  OrderInfo
      name: 'OrderInfo',
      component: resolve => require(['@/pages/OrderManage/OrderInfo'], resolve)
    }
    ]
  }

  ]
})

// 路由限制登录权限
router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) { // 判断该路由是否需要登录权限
    if (sessionStorage.getItem('username')) {
      next()
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js